<template lang="html">

    <el-form ref="form" v-form :model="form" addAction="distributor/saveDbtSetting.action" editAction="distributor/saveDbtSetting.action" selectAction="distributor/selectDbtSetting.action"
             :rules="rules" label-width="150px">

        <el-row>
          <h3 style="margin-left:8px;">商品交易佣金设置</h3>
          <p style="margin-left:8px;color: #909399">当商户线上销售商品时，商户需按照每笔订单用户实际付款金额的3%支付平台服务费，服务费将按照以下参数设置用于推广佣金奖励。(扣除所有佣金奖励后剩余服务费，则按照合作分成比例以月/季度进行后结算)</p>
        <p  style="margin-left:8px;color: red">
            举例：若设置招募者奖励5%，经纪人奖励50%，合伙人奖励20%，当用户购买商品实际支付100元，即服务费为3元，则：

            招募者获得收益：3x5%=0.15元

            经纪人获得收益：3x50%=1.5元

            合伙人获得收益：3x20%=0.6元

            运营方获得收益：（3-0.15-1.5-0.6）x分成比例<br>
        </p>
        </el-row>
        <el-row>

            <el-col :span="6">
                <el-form-item label="经纪人奖励" prop="cosmetologyAgentRadio">
                    <el-input  v-model.number="form.cosmetologyAgentRadio" placeholder=""  type="text" step="0" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-col>

        </el-row>

        <el-row>

        <el-col :span="6">
            <el-form-item label="合伙人奖励" prop="cosmetologyDealerRadio">
                <el-input  v-model.number="form.cosmetologyDealerRadio" placeholder=""  type="text" step="0" >
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
        </el-col>
    </el-row>

        <el-row>

            <el-col :span="6">
                <el-form-item label="招募者奖励" prop="cosmetologyRecruiterRadio">
                    <el-input  v-model.number="form.cosmetologyRecruiterRadio" placeholder=""  type="text" step="0" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>

            <h3 style="margin-left:8px;">提现手续费参数设置</h3>
        </el-row>
        <el-row>
            <el-col :span="6">
                <el-form-item label="经纪人提现手续费" prop="memberWithdrawChargeRatio">
                    <el-input   v-model="form.memberWithdrawChargeRatio" placeholder=""  type="text" step="0" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-col>

        </el-row>

        <el-row>
            <el-col :span="6">
                <el-form-item label="商家提现手续费" prop="businessWithdrawChargeRatio">
                    <el-input  v-model="form.businessWithdrawChargeRatio" placeholder=""  type="text" step="0" >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-col>
        </el-row>

        <el-col>
            <el-form-item>
                <el-button type="primary"  >保存</el-button>

            </el-form-item>
        </el-col>

    </el-form>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'

export default {
  extends: BasicPager,
  components: {

  },
  data: function () {
    var checkNumberInfo = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{1})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留一位哦！'))
      }
      callback()
    }
    return {
      baseUrl: Config.baseUrl,
      isAdmin: null,
      form: {
        channelId: null,
        id: null,
        newCarPublish: null,
        secondHandCaPublishr: null,
        cosmetologyPublish: null,
        carWashPublish: null,
        decoratePublish: null,
        refitPublish: null,
        carMaintenancePublish: null,
        otherServicePublish: null,
        cosmetologyRadio: null,
        cosmetologyAgentRadio: null,
        cosmetologyDealerRadio: null,
        cosmetologyRecruiterRadio: null,
        carWashRadio: null,
        carWashAgentRadio: null,
        carWashDealerRadio: null,
        carWashRecruiterRadio: null,
        decorateRadio: null,
        decorateAgentRadio: null,
        decorateDealerRadio: null,
        decorateRecruiterRadio: null,
        refitRadio: null,
        refitAgentRadio: null,
        fefitDealerRadio: null,
        refitRecruiterRadio: null,
        carMaintenanceRadio: null,
        carMaintenanceAgentRadio: null,
        carMaintenanceDealerRadio: null,
        carMaintenanceRecruiterRadio: null,
        otherServiceRadio: null,
        otherServiceAgentRadio: null,
        otherServiceDealerRadio: null,
        otherRecruiterRadio: null,
        businessWithdrawChargeRatio: null,
        memberWithdrawChargeRatio: null
      },
      rules: {
        newCarPublish: [{
          required: true,
          trigger: 'change',
          message: '新车发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '新车发布只能为数字！'
        }
        ],
        secondHandCaPublishr: [{
          required: true,
          trigger: 'change',
          message: '二手车发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '二手车发布只能为数字！'
        }],
        cosmetologyPublish: [{
          required: true,
          trigger: 'change',
          message: '机油保养发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '机油保养发布只能为数字！'
        }],
        carWashPublish: [{
          required: true,
          trigger: 'change',
          message: '洗车打蜡发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '洗车打蜡发布只能为数字！'
        }],
        decoratePublish: [{
          required: true,
          trigger: 'change',
          message: '汽车用品发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车用品发布只能为数字！'
        }],
        refitPublish: [{
          required: true,
          trigger: 'change',
          message: '改装装潢发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '改装装潢发布只能为数字！'
        }],
        carMaintenancePublish: [{
          required: true,
          trigger: 'change',
          message: '汽车维修发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车维修发布只能为数字！'
        }],
        otherServicePublish: [{
          required: true,
          trigger: 'change',
          message: '其他服务发布不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '其他服务发布只能为数字！'
        }],
        cosmetologyRadio: [{
          required: true,
          trigger: 'change',
          message: '平台服务费不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '平台服务费只能为数字！'
        }],
        cosmetologyAgentRadio: [{
          required: true,
          trigger: 'change',
          message: '经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '经纪人奖励只能为数字！'
        }],
        cosmetologyDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '合伙人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '合伙人奖励只能为数字！'
        }],
        cosmetologyRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '招募者奖励只能为数字！'
        }],
        carWashRadio: [{
          required: true,
          trigger: 'change',
          message: '洗车打蜡平台服务费不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '洗车打蜡平台服务费只能为数字！'
        }],
        carWashAgentRadio: [{
          required: true,
          trigger: 'change',
          message: '洗车打蜡经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '洗车打蜡经纪人奖励只能为数字！'
        }],
        carWashDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '洗车打蜡合伙人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '洗车打蜡合伙人奖励只能为数字！'
        }],
        carWashRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '招募者奖励只能为数字！'
        }],
        decorateRadio: [{
          required: true,
          trigger: 'change',
          message: '汽车用品平台服务费不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车用品平台服务费只能为数字！'
        }],
        decorateAgentRadio: [{
          required: true,
          trigger: 'change',
          message: '汽车用品经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车用品经纪人奖励只能为数字！'
        }],
        decorateDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '汽车用品合伙人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车用品合伙人奖励只能为数字！'
        }],
        decorateRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '招募者奖励只能为数字！'
        }],
        refitRadio: [{
          required: true,
          trigger: 'change',
          message: '改装装潢平台服务费不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '改装装潢平台服务费只能为数字！'
        }],
        refitAgentRadio: [{
          required: true,
          trigger: 'change',
          message: '改装装潢经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '改装装潢经纪人奖励只能为数字！'
        }],
        fefitDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '改装装潢合伙人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '改装装潢合伙人奖励只能为数字！'
        }],
        refitRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '招募者奖励只能为数字！'
        }],
        carMaintenanceRadiao: [{
          required: true,
          trigger: 'change',
          message: '汽车维修平台服务费不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车维修平台服务费只能为数字！'
        }],
        carMaintenanceAgentRadio: [{
          required: true,
          trigger: 'change',
          message: '汽车维修经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车维修经纪人奖励只能为数字！'
        }],
        carMaintenanceDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '汽车维修合伙人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '汽车维修合伙人奖励只能为数字！'
        }],
        carMaintenanceRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '招募者奖励只能为数字！'
        }],
        otherServiceRadio: [{
          required: true,
          trigger: 'change',
          message: '其他服务平台服务费不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '其他服务平台服务费只能为数字！'
        }],
        otherServiceAgentRadio: [{
          required: true,
          trigger: 'change',
          message: '其他服务平台经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '其他服务平台经纪人奖励只能为数字！'
        }],
        otherServiceDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '其他服务经销商平台奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '其他服务经销商平台奖励只能为数字！'
        }],
        otherRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '招募者奖励只能为数字！'
        }],
        businessWithdrawChargeRatio: [{
          required: true,
          trigger: 'change',
          message: '商家提现手续费不能为空！'
        },
        { validator: checkNumberInfo, trigger: 'blur' }],
        memberWithdrawChargeRatio: [{
          required: true,
          trigger: 'change',
          message: '经纪人提现手续费不能为空！'
        },
        { validator: checkNumberInfo, trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    if (userInfo.loginPath === 'channel') {
      this.form.id = this.loginInfo.id
    }
  },
  methods: {

    showMsg: function (dataInfo) {
      if (dataInfo.success) {
        this.$message({
          type: 'success',
          message: dataInfo.errMsg
        })
      } else {
        this.$message({
          type: 'error',
          message: dataInfo.errMsg
        })
      }

      this.selectInfo()
    },
    onAdded: function (dataInfo) {
      this.showMsg(dataInfo)
    },
    onEdited: function (dataInfo) {
      this.showMsg(dataInfo)
    }
  }
}
</script>
